import React, { useState } from "react";
import "./doctorInfo.css";
import { useSelector } from "react-redux";
import { selectDoctorId, selectLanguage } from "../../Login/loginSlice";
import { texts } from "../../Common/common";
import { Price } from "./Price";
import ActMenu from "./ActMenu";
import InvoiceMenu from "./InvoiceMenu";

const DoctorInfo = ({
    doctorName,
    doctorCompany,
    allDebet,
    is_pay,
    setIs_pay,
    hasCustomPrices,
    setHasCustomPrices,
    selectForAct,
    setSelectForAct,
    selectForInvoice,
    setSelectForInvoice,
    selectedOrders,
    setSelectedOrders,
    onGenerateAct,
    onGenerateInvoice,
    onSelectAllOrders,
    onSelectMonth,
    selectedMonth,
    orders
}) => {
    const currentLanguage = useSelector(selectLanguage);
    const doctor_id = useSelector(selectDoctorId)

    const [showPrice, setShowPrice] = useState(false);

    // Обработчик кнопки "Акт"
    const handleToggleSelectForAct = () => {
        setSelectForAct(!selectForAct);
        setSelectForInvoice(false); // отключить режим счета при включении акта
        if (selectForAct) setSelectedOrders([]); // сбросить при выходе из режима
    };

    // Обработчик кнопки "Счет"
    const handleToggleSelectForInvoice = () => {
        setSelectForInvoice(!selectForInvoice);
        setSelectForAct(false); // отключить режим акта при включении счета
        if (selectForInvoice) setSelectedOrders([]); // сбросить при выходе из режима
    };

    const monthsList = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    return (
        <div className="doctor-info">
            <div className="doctor-details">
                <div className="doctor-row">
                    <span>{texts[currentLanguage].dentist}</span>
                    <strong>{doctorName}</strong>
                </div>
                <div className="doctor-row">
                    <span>{texts[currentLanguage].clinic}</span>
                    <strong>{doctorCompany}</strong>
                </div>
                <div className="doctor-row">
                    <span>{texts[currentLanguage].debt}</span>
                    <strong>
                        {allDebet} {texts[currentLanguage].rub}
                    </strong>
                </div>
            </div>

            <div className="doctor-actions">
                {selectForAct ? (
                    <ActMenu
                        onGenerate={onGenerateAct}
                        onSelectAll={onSelectAllOrders}
                        onSelectMonth={onSelectMonth}
                        selectedMonth={selectedMonth}
                        monthsList={monthsList}
                        onClose={() => setSelectForAct(false)}
                        orders={orders}
                        selectedOrders={selectedOrders}
                    />
                ) : selectForInvoice ? (
                    <InvoiceMenu
                        onGenerate={onGenerateInvoice}
                        onSelectAll={onSelectAllOrders}
                        onSelectMonth={onSelectMonth}
                        selectedMonth={selectedMonth}
                        monthsList={monthsList}
                        onClose={() => setSelectForInvoice(false)}
                        orders={orders}
                        selectedOrders={selectedOrders}
                    />
                ) : (
                    <>
                        <div className="actions-column">
                            <button
                                className={`pay-status ${is_pay === "paid" ? "paid" : ""}`}
                                onClick={() => setIs_pay(is_pay === "paid" ? "all" : "paid")}
                            >
                                {texts[currentLanguage].paid}
                            </button>

                            <button
                                className={`pay-status ${is_pay === "debt" ? "debt" : ""}`}
                                onClick={() => setIs_pay(is_pay === "debt" ? "all" : "debt")}
                            >
                                {texts[currentLanguage].debt}
                            </button>
                        </div>

                        <div className="actions-column">
                            <button
                                className={`price-btn ${hasCustomPrices ? "custom" : ""}`}
                                onClick={() => setShowPrice(true)}
                            >
                                {texts[currentLanguage].price}
                            </button>

                            <button
                                className="price-btn"
                                onClick={handleToggleSelectForAct}
                            >
                                Акт
                            </button>

                            <button
                                className="price-btn"
                                onClick={handleToggleSelectForInvoice}
                            >
                                Счет
                            </button>
                        </div>
                    </>
                )}
            </div>
            {showPrice && (
                <Price
                    doctor_id={doctor_id}
                    doctorCompany={doctorCompany}
                    setShowPrice={setShowPrice}
                    setHasCustomPrices={setHasCustomPrices}
                />
            )}
        </div>
    );
};

export default DoctorInfo;
